import React, { FC } from 'react';
import styled from 'styled-components';

const ColorPreview = styled.div<{ $color: string; $roundedLeft?: boolean; $roundedRight?: boolean; $width: number }>`
    width: ${({ $width }) => $width}px;
    height: 32px;
    background-color: ${({ $color }) => $color};
    border-radius: ${({ $roundedLeft, $roundedRight }) => {
        if ($roundedLeft && $roundedRight) return '5.75px';
        if ($roundedLeft) return '5.75px 0 0 5.75px';
        if ($roundedRight) return '0 5.75px 5.75px 0';
        return '0';
    }};
`;

export const PaletteColorPreview: FC<{ colors: { rgbHexCode: string }[]; maxSlots: number }> = ({ colors, maxSlots }) => {
    const totalWidth = 192; // 6 * 32px
    const previewColors = colors.slice(0, maxSlots);
    const slotWidth = totalWidth / colors.length;

    return (
        <div style={{ display: 'flex', alignItems: 'center', width: totalWidth }}>
            {[...previewColors].map((color, index) => {
                const roundedLeft = index === 0;
                const roundedRight = index === previewColors.length - 1;
                return <ColorPreview key={index} $color={color.rgbHexCode} $roundedLeft={roundedLeft} $roundedRight={roundedRight} $width={slotWidth} />;
            })}
            {colors.length > maxSlots && <span>+{colors.length - maxSlots}</span>}
        </div>
    );
};
